import { useState } from "react"
import { Button } from "../../ui/buttons/Button"
import ModalWrapper from "../../ui/modals/ModalWrapper"
import { PauseNotificationsDialog, NotificationsMessageDialog } from "./components/PauseNotificationsMessageDialog"
import { useUser } from "../../../contexts/UserContext"
import { useRunMessages } from "@contexts/runMessages/RunMessageContext"
/**
 * Parent Component for Controls in Live Track Edit
 * -Stop Notifications
 * -Restart Notifications
 * -Send run message
 * 
 * @param {number} selectedRun
 * @param {Boolean} notificationsPaused
 * 
 * @returns {JSX.Element}
 * 
 */
export const LiveTrackControl = ({selectedRun, notificationsPaused}) => {
    const [showPauseModal, setShowPauseModal] = useState(false)
    const [showMessageModal, setShowMessageModal] = useState(false)

    const { userGroups } = useUser()
    const {handleCreateRunMessage, handlePauseUnpause} = useRunMessages()

    const hasPermission = userGroups?.includes("Admin") || userGroups?.includes("Project Manager") || userGroups?.includes("Supervisor")

    return (
        <>
            {hasPermission ? (
                <div className="flex justify-end mt-10">
                <div className="mb-10">
                    <Button
                        onClick={() =>{
                            setShowMessageModal(true)
                            setShowPauseModal(false)
                        }}
                        className="mr-2 mb-2"
                    >
                        Send Message
                    </Button>
                    <Button
                        variant="caution"
                        onClick={() =>{
                            setShowPauseModal(true)
                            setShowMessageModal(false)
                        }}
                    >
                        {notificationsPaused ? 
                            <span><i className="fa-solid fa-circle-play"></i> Unpause Notifications</span>
                        : 
                            <span><i className="fa-solid fa-circle-pause"></i> Pause Notifications</span>

                        }
                    </Button>
                </div>

                <ModalWrapper
                    isOpen={showPauseModal}
                    onClose={() => setShowPauseModal(false)}
                >
                    <PauseNotificationsDialog
                        selectedRun ={selectedRun}
                        setShowModal={setShowPauseModal}
                        isPaused={notificationsPaused}
                        handleSubmit={handlePauseUnpause}
                    />
                </ModalWrapper>

                <ModalWrapper
                    isOpen={showMessageModal}
                    onClose={() => setShowMessageModal(false)}
                >
                    <NotificationsMessageDialog
                        selectedRun ={selectedRun}
                        setShowModal={setShowMessageModal}
                        handleSubmit={handleCreateRunMessage}
                    />
                </ModalWrapper>
            </div>
            ) : null}
        </>
        
    )
}